import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { orderAPI } from '../api/services';
import './Orders.css';

function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await orderAPI.getOrders();
      setOrders(response.data);
    } catch (error) {
      console.error('Failed to fetch orders', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    return `status-badge status-${status}`;
  };

  return (
    <div className="orders-page">
      <div className="container">
        <h1>My Orders</h1>

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : orders.length === 0 ? (
          <div className="no-orders">
            <h2>No orders yet</h2>
            <p>Start shopping to place your first order</p>
            <Link to="/products" className="btn btn-primary">Continue Shopping</Link>
          </div>
        ) : (
          <div className="orders-list">
            {orders.map((order) => (
              <Link key={order.id} to={`/orders/${order.id}`} className="order-card card">
                <div className="order-header">
                  <div>
                    <h3>Order #{order.id}</h3>
                    <p className="order-date">
                      {new Date(order.created_at).toLocaleDateString('en-PK', { timeZone: 'Asia/Karachi' })}
                    </p>
                  </div>
                  <span className={getStatusBadgeClass(order.status)}>
                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                  </span>
                </div>

                <div className="order-body">
                  <div className="order-info">
                    <div>
                      <span className="label">Items:</span>
                      <span className="value">{order.items.length} product{order.items.length !== 1 ? 's' : ''}</span>
                    </div>
                    <div>
                      <span className="label">Delivery:</span>
                      <span className="value">{order.delivery_address.substring(0, 30)}...</span>
                    </div>
                  </div>

                  <div className="order-amount">
                    <span className="label">Total Amount</span>
                    <span className="amount">Rs {(order.total_amount + order.tax_amount + order.shipping_amount).toFixed(0)}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Orders;
